module.exports = __webpack_public_path__ + "img/AI.836cb166.png";